import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SkeletonProps } from '../../interfaces/SkeletonProps';

import PlaceholderBar from '../PlaceholderBar/PlaceholderBar';
import Refresh from '../Refresh/Refresh';

export const DonationPromptsSkeleton: FunctionComponent<SkeletonProps> = ({
  animated,
  displayRefreshButton,
  onRefresh,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <Refresh
      className={classNames('jg-display-flex jg-flex-column jg-flex-aic')}
      displayRefreshButton={displayRefreshButton}
      onRefresh={onRefresh}
      buttonLabel={t('donationPrompts.refresh')}
    >
      <PlaceholderBar
        width="100%"
        height={40}
        animated={animated}
        className="jg-space-mbn"
      />
      <PlaceholderBar
        width="100%"
        height={40}
        animated={animated}
        className="jg-space-mbn"
      />
      <PlaceholderBar
        width="100%"
        height={40}
        animated={animated}
        className="jg-space-mbsm"
      />
      <PlaceholderBar width="100%" height={48} animated={animated} />
    </Refresh>
  );
};
